export const getRoleName = (roleId, roles) => {
  const found = roles.find((role) => role.id == roleId);
  return found ? found.label : null;
};

export const getRoles = (roleIdsString, roles) => {
  const roleIds = roleIdsString.replace(/\s/g, "").split(",");
  return roles.filter((role) => roleIds.includes(role.id));
};
